import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { SgoProjeto } from '../models/sgo-projeto.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SgoProjetoService extends BaseService<SgoProjeto> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getInfoSgo(id: string): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/info', { id: id }, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/sgo';
  }

}
